import { render, staticRenderFns } from "./zhTw.vue?vue&type=template&id=3173d4b0&"
import script from "./zhTw.vue?vue&type=script&lang=js&"
export * from "./zhTw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports